<template>
    <form-save 
        modelName="Categoria" 
        saveUrl="checklist-categories/" 
        operation="post"
        id=""
        backUrl="/checklist-categories"
        icon="fa-list-ul"
        ></form-save>
</template>

<script>
import FormSave from "./FormSave";
export default {
  components: {
    FormSave
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/ChecklistCategory/Add.vue